import Symbol           from 'es6-symbol/polyfill';
import EventEmitter     from 'events';
import UsersService     from '@/services/Users';
import OrdersService     from '@/services/Orders';

let singleton = Symbol();
let singletonEnforcer = Symbol();

class AppControlService extends EventEmitter {

  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this._currentStep = 0;
    this._isAuthByStep = false;

    this.on('validating', (step) => {
      if(step === 0) this.goToNextStep();
    })
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new AppControlService(singletonEnforcer);
    }
    return this[singleton];
  }

  get currentStep() {
    return this._currentStep;
  }

  get isAuthByStep() {
    return this._isAuthByStep;
  }

  abortStep() {
    this.emit('aborted', this._currentStep);
  }

  validStep() {
    this.emit('validating', this._currentStep);
  }

  goTo(step) {
    this._currentStep = this._stepControl( step );
    this.emit('step', this._currentStep);
  }

  goToNextStep() {
    this._currentStep = this._stepControl( this._currentStep + 1);
    this.emit('step', this._currentStep);
  }

  _stepControl(step) {
    if( !UsersService.isConnected) {
      this._isAuthByStep = true;
      window.openLogin();
      document.body.addEventListener('logged', () => {
        UsersService.me().then(() => {
          OrdersService.get().then(() => {
            this.goTo(step);
          })
        })
      }, {once: true});
      return 0;
    }
    if( step >= 0 && OrdersService.cart.items.length === 0 ) return 0;
    return step;
  }

}
export default AppControlService.getInstance();